export default __webpack_public_path__ + "static/media/card-3.5c549b85.jpeg";